module.exports = __webpack_public_path__ + "static/media/btcd.8586e60f.svg";